<template>
  <ValidationObserver ref="validationObserver">
    <div class="bundle-availability">
      <ContentBlock :required="true">
        <div slot="instructions">
          <h5>{{ $t('Availability') }}</h5>
          <p>{{ $t("Put your bundle on the marketplace.") }}</p>
        </div>
        <div class="basics">
          <UISwitch
            :title="$t('Public')"
            v-model="bundle.public"
            @change="validate"
          />
          <div class="datepickers">
            <UIDatepicker
              :title="$t('Available from')"
              :instructions="$t('Inclusive date')"
              :options="datePickerOptions"
              v-model="bundle.availableFrom"
              @change="validate"
            />
            <UIDatepicker
              :title="$t('Available until')"
              :instructions="$t('Exclusive date')"
              :options="datePickerOptions"
              v-model="bundle.availableUntil"
              @change="validate"
            />
          </div>
        </div>
      </ContentBlock>
    </div>
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { ValidationObserver } from 'vee-validate';
import UISwitch from '../../../core/shared/components/ui/UISwitch.vue';
import UIDatepicker from '../../../core/shared/components/ui/UIDatepicker.vue';
import ContentBlock from '@/core/shared/components/ContentBlock';

@Component({
  components: {
    ValidationObserver,
    UISwitch,
    UIDatepicker,
    ContentBlock,
  },
  methods: {
    async validate () {
      const valid = await this.$refs.validationObserver.validate();
      if (valid !== this.formIsValid) {
        this.formIsValid = valid;
        this.$emit('valid', valid);
      }
    },
  },
  props: {
    bundle: {
      type: Object,
      required: true,
    },
    valid: {
      type: Boolean,
      required: false,
    },
  },
})
export default class SetupAvailability extends Vue {
  datePickerOptions = {
    altFormat: 'F d, Y',
  };
};
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.bundle-availability {
  display: grid;
  grid-gap: var(--spacingMd);

  & .datepickers {
    display: grid;
    grid-gap: var(--spacingSm);

    @media (--tablet) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

.basics {
  & > * {
    margin-bottom: var(--spacingMd);
  }
}
</style>
